import { NgModule } from '@angular/core';
import { Routes, RouterModule, RouteReuseStrategy } from '@angular/router';
import { LoginComponent } from '../accounts/components/login/login.component';
import { PlantingSiteListComponent } from './planting-site-list/planting-site-list.component';
import { CurrentUserResolverService } from '../core/services/current-user-resolver.service';
import { PlantingSitesResolverService } from '../core/services/planting-sites-resolver.service';
import { CustomersComponent } from './customers/customers.component';
import { BackendComponent } from './backend.component';
import { PlantingSiteDetailsComponent } from './planting-site-details/planting-site-details.component';
import { PlantingSiteDetailsResolverService } from './planting-site-details/planting-site-details-resolver.service';
import { CanDeactivateService } from '../core/services/can-deactivate.service';
import { RouteGuardService } from '../core/services/route-guard.service';
import { CustomersResolverService } from './customers/customers-resolver.service';
import { CustomerCountriesResolverService } from './customers/customer-countries-resolver.service';
import { CustomerDetailsResolverService } from './customers/customer-details/customer-details-resolver.service';
import { CustomerDetailsComponent } from './customers/customer-details/customer-details.component';
import { ApplicationConfigResolverService } from '../core/services/application-config-resolver.service';
import { UsersComponent } from './users/users.component';
import { UsersResolverService } from './users/users-resolver.service';
import { UserDetailsComponent } from './users/user-details/user-details.component';
import { UserDetailsResolverService } from './users/user-details/user-details-resolver.service';
import { TreeSpeciesComponent } from './tree-species/tree-species.component';
import { TreeSpeciesResolverService } from './tree-species/tree-species-resolver.service';

const routes: Routes = [
    {path: 'login', component: LoginComponent},
    {
        path: '',
        component: BackendComponent,
        canActivate: [RouteGuardService],
        resolve: {appConfig: ApplicationConfigResolverService},
        canActivateChild: [RouteGuardService],
        children: [
            {
                path: 'plantingSites',
                children: [
                    {
                        path: '', pathMatch: 'full',
                        component: PlantingSiteListComponent,
                        resolve: {plantingSites: PlantingSitesResolverService},
                        data: {
                            showYearPickerCalendar: false
                        }
                    },
                    {
                        path: ':siteId',
                        resolve: {
                            plantingSite: PlantingSiteDetailsResolverService,
                            currentUser: CurrentUserResolverService
                        },
                        children: [
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'general'
                            },
                            {
                                path: ':tab',
                                component: PlantingSiteDetailsComponent,
                                canDeactivate: [CanDeactivateService],
                                data: {reusePath: ':tab/:tabId'}
                            },
                            {
                                path: ':tab/:tabId',
                                component: PlantingSiteDetailsComponent,
                                canDeactivate: [CanDeactivateService],
                                data: {reusePath: ':tab/:tabId'}
                            },
                            {
                                path: ':tab/:tabId/:secondtab',
                                component: PlantingSiteDetailsComponent,
                                canDeactivate: [CanDeactivateService],
                                data: {reusePath: ':tab/:tabId/:secondtab'}
                            },
                            {
                                path: ':tab/:tabId/:secondtab/:secondtabId',
                                component: PlantingSiteDetailsComponent,
                                canDeactivate: [CanDeactivateService],
                                data: {reusePath: ':tab/:tabId/:secondtab/:secondtabId'}
                            },
                        ]
                    }
                ]
            },
            {
                path: 'customers',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        component: CustomersComponent,
                        resolve: {customers: CustomersResolverService}
                    },
                    {
                        path: ':id',
                        canDeactivate: [CanDeactivateService],
                        resolve: {
                            customer: CustomerDetailsResolverService,
                            countries: CustomerCountriesResolverService,
                        },
                        component: CustomerDetailsComponent
                    }
                ]

            },
            {
                path: 'users',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        component: UsersComponent,
                        resolve: {users: UsersResolverService}
                    },
                    {
                        path: ':id',
                        canDeactivate: [CanDeactivateService],
                        component: UserDetailsComponent,
                        resolve: {user: UserDetailsResolverService},
                    }
                ]

            },
            {
                path: 'treeSpecies',
                component: TreeSpeciesComponent,
                resolve: {species: TreeSpeciesResolverService},
                data: {
                  title: 'Tree Species'
                }
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BackendRoutingModule {}
